import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

import { IBusinessTypeColor } from "./types";

export const columns = [
  "Business Name",
  "Owner's Name",
  "Business Type",
  "Current Balance",
  "Compliance",
  "Date Joined",
  "Status",
  "",
];

export const BUSINESSES_LIST_TABLE_PAGE_LIMIT = 10;
export const BUSINESSES_LIST_TABLE_PAGINATION_PARAMS: IPaginationParams = {
  page: PAGE_ONE,
  limit: BUSINESSES_LIST_TABLE_PAGE_LIMIT,
};

export const BusinessTypeColorMap: Record<string, IBusinessTypeColor> = {
  registered: {
    color: "#175CD3",
    bg: "#EFF8FF",
  },
  unregistered: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  default: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  "-": {
    color: "#344054",
    bg: "#F2F4F7",
  },
};
